import React from "react";
import { Card } from "../../components/AdminSharedComponents";
import { Folder, CheckCircle, Clock, FileText } from "lucide-react";

const ProjectStats = ({ projects, projectReports }) => {
  const totalProjects = projects.length;
  const completedProjects = projects.filter(
    (p) => p.status === "Completed"
  ).length;
  const inProgressProjects = projects.filter(
    (p) => p.status === "In Progress"
  ).length;
  const totalReports = Object.values(projectReports).reduce(
    (sum, reports) => sum + reports.length,
    0
  );

  const stats = [
    {
      icon: Folder,
      label: "Total Projects",
      value: totalProjects,
      color: "text-primary",
      bg: "bg-primary/10",
    },
    {
      icon: CheckCircle,
      label: "Completed",
      value: completedProjects,
      color: "text-emerald-600",
      bg: "bg-emerald-50",
    },
    {
      icon: Clock,
      label: "In Progress",
      value: inProgressProjects,
      color: "text-yellow-600",
      bg: "bg-yellow-50",
    },
    {
      icon: FileText,
      label: "Total Reports",
      value: totalReports,
      color: "text-blue-600",
      bg: "bg-blue-50",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats.map((stat, index) => (
        <Card key={index} className="p-4">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${stat.bg}`}>
              <stat.icon className={`h-5 w-5 ${stat.color}`} />
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-900">
                {stat.value}
              </div>
              <div className="text-sm text-gray-600">{stat.label}</div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default ProjectStats;
